/* eslint-disable functional/immutable-data */
import React, { ChangeEvent } from 'react'
import { TextField, IconButton, InputAdornment } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import { useLang } from '~/hooks/useLang'
import { State } from '@hookstate/core'

type InputOccurrenceNumberProps = {
  readonly occurrence?: State<string | null>
  readonly onOccurrenceChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export default function InputOccurrenceNumber({
  occurrence,
  onOccurrenceChange,
}: InputOccurrenceNumberProps) {
  const { translate } = useLang()

  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    if (value === '' || /^[0-9]*$/.test(value)) {
      onOccurrenceChange(event)
    } else {
      event.target.value = occurrence?.get() ?? ''
    }
  }

  const handleClear = () => {
    if (occurrence) {
      occurrence.set(null)
    }
    const event = {
      target: { value: '' },
    } as ChangeEvent<HTMLInputElement>
    onOccurrenceChange(event)
  }

  return (
    <TextField
      fullWidth
      type="text"
      inputProps={{
        pattern: '[0-9]*',
        inputMode: 'numeric',
      }}
      InputProps={{
        endAdornment: occurrence?.get() && (
          <InputAdornment position="end">
            <IconButton
              aria-label="clear input"
              onClick={handleClear}
              edge="end"
              size="small"
            >
              <CancelIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
          {
            display: 'none',
          },
        '& input': {
          MozAppearance: 'textfield',
        },
      }}
      label={`${translate('Occurrence ID')}`}
      size="small"
      value={occurrence?.get() ?? ''}
      onInput={handleInput}
      onChange={onOccurrenceChange}
    />
  )
}
